import 'slick-slider';
const imageShowMod = () => {
	let imageShowFade = $('.imageShow__fade');

	if (imageShowFade) {
		function getRandomNumber(min, max) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		}
		imageShowFade.each(function (num, elem) {
			let randomNumber = getRandomNumber(2, 7);
			randomNumber = randomNumber * 1000;
			elem = $(elem);
			elem.slick({
				arrows: false,
				slidesToShow: 1,
				infinite: true,
				fade: true,
				autoplay: true,
				speed: 1050,
				autoplaySpeed: randomNumber,
				cssEase: 'linear',
			});
		});
	}
};

export default imageShowMod;
